import {
  InputSelectControlField,
  Tooltip,
  useModalState,
  GreyGrey60,
  RedRed60,
  IconExclamationCircle,
  Box
} from '@sequencehq/core-components'
import { useSeatMetrics } from 'Seats/SeatMetric/useSeatMetrics'
import { CreateSeatTypeDrawer } from './CreateSeatTypeDrawer'
import Spinner from 'components/Loading'
import { match } from 'ts-pattern'
import { useMemo } from 'react'

type SeatType = string
interface Props
  extends Omit<
    React.ComponentProps<typeof InputSelectControlField>,
    | 'options'
    | 'onChange'
    | 'placeholder'
    | 'initialValue'
    | 'createLabel'
    | 'onCreate'
  > {
  onChange: (seatType: SeatType) => void
  value?: SeatType
  allowCreate?: boolean
}

/**
 * Returns the seat type of the selected metric
 * @param param0
 * @returns
 */
export const SeatTypeSelect = ({
  value,
  onChange,
  allowCreate = true,
  ...selectControlProps
}: Props) => {
  const { isModalOpen, openModal, closeModal } = useModalState()
  const { metrics, loading, error } = useSeatMetrics()

  const trailingIcon = useMemo(
    () =>
      match({ loading, error })
        .with({ error: true }, () => (
          <Tooltip label="Error loading seat types">
            <Box paddingRight="4px" pointerEvents="initial">
              <IconExclamationCircle color={RedRed60} />
            </Box>
          </Tooltip>
        ))
        .with({ loading: true }, () => (
          <Tooltip label="Loading seat types...">
            <Box paddingRight="4px" pointerEvents="initial">
              <Spinner color={GreyGrey60} height="16px" width="16px" />
            </Box>
          </Tooltip>
        ))
        .otherwise(() => undefined),
    [loading, error]
  )

  return (
    <>
      <InputSelectControlField
        options={metrics.map(item => ({
          value: item.seatType,
          label: item.seatType,
          secondaryLabel: item.label
        }))}
        onChange={onChange}
        placeholder="Select seat type"
        initialValue={value}
        createLabel={allowCreate ? 'Create new seat metric' : undefined}
        trailingIcon={trailingIcon}
        onCreate={
          allowCreate
            ? () => {
                openModal()
              }
            : undefined
        }
        {...selectControlProps}
      />
      <CreateSeatTypeDrawer
        isOpen={isModalOpen}
        onClose={closeModal}
        onCreate={seatMetric => {
          onChange(seatMetric.seatType)
        }}
      />
    </>
  )
}
